import { render, staticRenderFns } from "./AdminUserIcon.vue?vue&type=template&id=78a5f7f6&scoped=true&"
import script from "./AdminUserIcon.vue?vue&type=script&lang=js&"
export * from "./AdminUserIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a5f7f6",
  null
  
)

export default component.exports